import { Container } from '@components/Component/Container/Container.js';
import { isMobile } from '@components/Utility/index.js';
export class QStrapContainer extends Container {
    constructor() {
        super(...arguments);
        this._currentBreakpoint = '';
    }
    get currentBreakpoint() {
        return this._currentBreakpoint;
    }
    set currentBreakpoint(value) {
        this._propertySet('currentBreakpoint', value);
    }
    renderWidth() {
        super.renderWidth();
        this.updateScreenBreakpoint();
    }
    draw() {
        super.draw();
        this.updateScreenBreakpoint();
    }
    /**
     * Because bootstrap relies on media queries which we cant use due to no iframes, we will maintain custom breakpoints on the screen-content container.
     * @protected
     */
    updateScreenBreakpoint() {
        if (!this.drawn) {
            return;
        }
        const container = this.contentContainer || this.rootElement;
        if (container) {
            // add screen content if it doesn't have it
            container.classList.add('screen-content');
            // Clear the existing timeout, if any
            clearTimeout(this.debounceResizeTimeout);
            if (this.rootElement.style.width && this.rootElement.style.width !== this.width) {
                //console.log('width sync', this.rootElement.style.width, this.width, this.contentContainer)
                // sync our property with the root element. This will result in calling updateScreenBreakpoint again in renderWidth hence the return.
                this.width = this.rootElement.style.width; // keep the class property in sync with root element
                return;
            }
            // Set a new timeout
            // this.debounceResizeTimeout = setTimeout(() => {
            let breakpoint = '';
            const width = container.offsetWidth;
            const classList = container.classList;
            const classNames = Array.from(classList);
            const matchingClasses = classNames.filter(className => className.startsWith('screen-') && className !== 'screen-content');
            matchingClasses.forEach((className) => classList.remove(className));
            if (width == 0) {
                breakpoint = this.currentBreakpoint === '' ? '' : `screen-${this.currentBreakpoint}`;
            }
            else if (width < 576) {
                breakpoint = 'screen-xs';
            }
            else if (width >= 576 && width < 768) {
                breakpoint = 'screen-sm';
            }
            else if (width >= 768 && width < 992) {
                breakpoint = 'screen-md';
            }
            else if (width >= 992 && width < 1200) {
                breakpoint = 'screen-lg';
            }
            else if (width >= 1200) {
                breakpoint = 'screen-xl';
            }
            //console.log('%cnew width', 'color: magenta', width, breakpoint, this.contentContainer);
            const xxsWidth = isMobile() ? 400 : 300;
            if (width < xxsWidth && width > 0) {
                // this breakpoint doesnt affect bootstrap classes, but it will force labels above inputs.
                // we could make this part of the bootstrap classes if we wanted to.
                classList.add('screen-xxs');
                if (this.currentBreakpoint !== 'xxs') {
                    this.currentBreakpoint = 'xxs';
                }
            }
            else {
                const _breakpoint = breakpoint.replace('screen-', '');
                if (this.currentBreakpoint !== _breakpoint) {
                    this.currentBreakpoint = _breakpoint;
                }
            }
            // set the breakpoint class
            if (breakpoint) {
                classList.add(breakpoint);
            }
            //this.contentContainer!.className = `screen-content ${breakpoint}`;
            // }, 15);
        }
    }
}
